module.exports = __webpack_public_path__ + "static/GloberBold-23d59e924299d5826a6e52a93020dae3.woff2";